export const errorHandler = (
  error: Error,
  errorInfo: { componentStack: string },
) => {
  // We can custom handle the the error here
};
